import { Segment } from 'component/Space/Segment'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { IdentityMode } from 'type/Identity'

type Props = {
  mode: IdentityMode
}

function getLabel(mode: IdentityMode): string | undefined {
  if (mode === 0) return i18n('mode.Base')
  if (mode === 1) return i18n('mode.Extended')
  if (mode === 2) return i18n('mode.Detailed')
}

export const Mode = observer(({ mode }: Props) => {
  const { form } = store.profile
  const size = opt.stand ? 16 : opt.tsum ? 15 : 10

  const onClick = useLatestCallback(() => {
    form.setMode(mode)
  })

  return <Segment active={form.mode === mode} action={onClick}>
    <Typo size={size}>
      {getLabel(mode)}
    </Typo>
  </Segment>
})
